import ninjaApi from 'store/redux/apis/ninja.api';

export const PostbackCampaignSpentApi = ninjaApi.injectEndpoints({
  overrideExisting: true,
  tagTypes: ['CampaignSpent'],
  endpoints: (build) => ({
    postbackCampaignSpentList: build.query({
      query: (body) => ({
        url: '/postback/campaign-spent/list',
        method: 'POST',
        body,
      }),
      providesTags: ['PostbackCampaignSpent'],
    }),

    postbackCampaignSpentSave: build.mutation({
      query: (body) => ({
        url: 'postback/campaign-spent/save',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['PostbackCampaignSpent'],
    }),
  }),
});

export const { usePostbackCampaignSpentListQuery, usePostbackCampaignSpentSaveMutation } =
  PostbackCampaignSpentApi;
